import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function AllPages() {
  return (
    <>
      <Link to="/">
        <button className="btn btn-primary m-3">صفحه اصلی</button>
      </Link>

      <Link to="/shop">
        <button className="btn btn-success m-3">فروشگاه</button>
      </Link>
      <Link to="/tours">
        <button className="btn btn-success m-3">تور ها</button>
      </Link>
      <Link to="/reserve-tour/4">
        <button className="btn btn-primary m-3">رزرو تور</button>
      </Link>

      <Link to="/single-tour">
        <button className="btn btn-success m-3">تک تور</button>
      </Link>
      <Link to="/admin-panel/tour-list">
        <button className="btn btn-success m-3">تور لیست</button>
      </Link>
      <Link to="/attractions">
        <button className="btn btn-success m-3">جاذبه های دیدنی</button>
      </Link>
      <Link to="/admin-panel/create-tour">
        <button className="btn btn-primary m-3">پنل ادمین - ساخت تور</button>
      </Link>
      <Link to="/admin-panel/user-management">
        <button className="btn btn-success m-3">پنل ادمین - مدیریت کاربران</button>
      </Link>
      <Link to="/admin-panel/campain-management">
        <button className="btn btn-success m-3">پنل ادمین - مدیریت کمپین</button>
      </Link>
      <Link to="/admin-panel/user-report/sfa">
        <button className="btn btn-success m-3"> پنل ادمین - گزارش کاربر</button>
      </Link>
      <Link to="/admin-panel/management">
        <button className="btn btn-success m-3">پنل ادمین - مدیریت </button>
      </Link>
      <Link to="/admin-panel/financial-department">
        <button className="btn btn-success m-3">پنل ادمین - امور مالی </button>
      </Link>
      <Link to="/admin-panel/reservation">
        <button className="btn btn-success m-3">پنل ادمین - رزرواسیون </button>
      </Link>
      <Link to="/customer-panel/profile">
        <button className="btn btn-success m-3">پنل مشتری - پروفایل </button>
      </Link>
      <Link to="/customer-panel/dashboard">
        <button className="btn btn-success m-3">پنل مشتری - داشوبرد </button>
      </Link>
      <Link to="/customer-panel/transactions">
        <button className="btn btn-success m-3">پنل مشتری - تراکنش هت </button>
      </Link>
      <Link to="/customer-panel/orders">
        <button className="btn btn-success m-3"> سفارشات من</button>
      </Link>
    </>
  );
}
